import { HttpClient } from '@angular/common/http';

import { BackendLoader } from '../../api-env';
import { ApiBase, WsBase } from '../base';

/**
 * @internal
 */
export class ApiBaseMidBack extends ApiBase {
  constructor(protected http: HttpClient) {
    super(http, { backendId: 'midBack', requestType: 'json' });
  }
}

/**
 * @internal
 */
export class WSBaseMidBack extends WsBase {
  constructor(
    protected loader: BackendLoader,
    protected accessToken: string,
  ) {
    super(loader, accessToken, { backendId: 'midBack' });
  }
}
